import { LoaderService } from '@tmhcc-ng-lib/framwork/loader';
import {
  AppDataService,
  StepResponse,
  StepsService,
  StepRequest,
  BaseSiteCoreAPIMapper,
  GlobalVariablesService,
  DocumentService,
  AvailableDocument,
  UploadFileService,
  BillingService,
  SaveSignatureMethodRequest,
  AgencyBillingResponse,
  RedirectPremiumFinancingResponse,
  RedirectInstallmentBillingResponse,
  ActivityLogRequest,
  DocumentsResponse,
  InstallmentBillingAcceptStatusRequest
} from '@tmhcc-ng-lib/data-service';
import {
  DialogService,
  DialogConfig,
  DialogSize
} from '@tmhcc-ng-lib/framwork/dialog';
import { SignApplicationComponent } from '../../sign-application/sign-application.component';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl
} from '@angular/forms';
import {
  FieldInfo,
  FieldTypes,
  InputConfig
} from '@tmhcc-ng-lib/framwork/form-inputs';
import { DateService } from '@tmhcc-ng-lib/framwork/services';
import { Router, ActivatedRoute } from '@angular/router';
import { BusinessInfoConfig } from '../../tabs/tab-cofig';
import { AlertTosterService } from '@tmhcc/framwork/alert-toster';
import { DatePipe } from '@angular/common';
import { ColumnDefinition } from '@tmhcc-ng-lib/framwork/grid';
import { has } from 'libs/util/has-value';
import { DownloadDocumentRequest } from 'libs/data-service/def/document';
import {
  DialogContainerComponent,
  SaveChangeGaurd
} from '@tmhcc-ng-lib/global-services';
import {
  AllowedBoundNavRoutes,
  BillingType,
  Messages,
  Status
} from '@tmhcc-ng-lib/models';
import { DomSanitizer } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { ViewChild, Directive } from '@angular/core';

@Directive()
export class BaseVerifyActionItemsComponent extends BusinessInfoConfig {
  public dtOptions: DataTables.Settings = {};
  public columnMaps: ColumnDefinition[];
  public linkData: any;
  public viewData: any;
  public tableDefinition;
  public actionItems: StepResponse;
  public documentsData: DocumentsResponse;
  public gridRefresh: boolean = false;
  public siteCoreData;
  public dateEdition: boolean = false;
  public requiredDocuments: any[];
  public fileToUpload: File = null;
  public fileReUpload: File = null;
  public appFileUpload: File = null;
  public appFileUploaded: boolean = false;
  public pendingFileUpload: File = null;
  public chooseFileFlag: boolean = false;
  public isRenewalNoDocument: boolean = false;
  public frmGroup: FormGroup;
  public frmDate: any;
  public toDate: any;
  public date: Date = new Date();
  public maxDate = new Date().setDate(this.date.getDate() + 60);
  public fromDatepickerInfo: FieldInfo = {
    placeholder: '',
    fieldName: 'fromDate',
    label: 'Date Picker',
    fieldType: FieldTypes.Date,
    showLabel: false,
    validations: {
      required: 'Please select a from date'
    }
  };
  public toDatepickerInfo: FieldInfo = {
    fieldName: 'toDate',
    label: 'Date Picker',
    placeholder: '',
    fieldType: FieldTypes.Date,
    showLabel: false,
    validations: {
      required: 'Please select a to date'
    }
  };
  public dateFromConfig: InputConfig;
  public dateToConfig: InputConfig;

  public modalContent: DialogConfig = {
    data: {
      para: '',
      label1: '',
      label2: ''
    },
    modalSetting: {
      title: '',
      hideHeader: false,
      hideFooter: true,
      hideHeaderX: false, // header X button;
      hideSave: true,
      closeOnOutsideClick: true
    }
  };
  public selectedPaymentMethod = '';
  public signatureMethod = '';
  public selectedAccordian = [true, false, false];
  public htmlContent: any;
  public redirectUrl: string;
  public premiumBillingGroup: FormGroup;
  public installmentAggrement: boolean;
  public installmentBillingDisplay: boolean;
  productName: string;
  constructor(
    protected loaderService: LoaderService,
    protected appDataService: AppDataService,
    protected dialogConfig: DialogConfig,
    protected dialogService: DialogService,
    protected stepsService: StepsService,
    protected fb: FormBuilder,
    protected alertService: AlertTosterService,
    protected datePipe: DatePipe,
    protected siteCoreAPIMapper: BaseSiteCoreAPIMapper,
    protected activatedRoute: ActivatedRoute,
    protected globalVariables: GlobalVariablesService,
    protected documentService: DocumentService,
    protected saveChangeGaurd: SaveChangeGaurd,
    protected dateservice: DateService,
    protected uploadFileService: UploadFileService,
    protected billingService: BillingService,
    protected router: Router,
    protected sanitizer: DomSanitizer,
    protected http: HttpClient
  ) {
    super(dateservice);
  }
  @ViewChild('premiumBilling') premiumBillingElement;

  callNgOnInit() {
    this.loaderService.show();
    this.appDataService.showSummary.next(true);
    this.appDataService.stepsSitecoreContent.next();
    this.appDataService.summarySitecoreContent.next();
    this.appDataService.getStepsSitecoreData().subscribe(res => {
      //this.loaderService.show();
      if (res) {
        this.siteCoreData = res;
        this.modalContent.data = {
          para: res.data[0].description
        };
        this.modalContent.modalSetting = {
          title: res.data[0].heading,
          hideFooter: true
        };
      }
      this.tableDefinition = this.siteCoreAPIMapper.fetchGridDataFromMappedSitecoreData(
        this.activatedRoute.snapshot.data['steps'],
        'Documents'
      );
    });

    this.dateFromConfig = {
      config: {
        datePickerConfig: {
          dateInputFormat: this.dateService.getFormat(),
          isCalanderRequired: true,
          minDate: this.date,
          maxDate: new Date(this.maxDate)
        }
      },
      fieldInfo: this.fromDatepickerInfo
    };
    this.dateToConfig = {
      config: {
        datePickerConfig: {
          dateInputFormat: this.dateService.getFormat(),
          isCalanderRequired: true
        },
        isDisabled: true
      },
      fieldInfo: this.toDatepickerInfo
    };
    this.initFormGroup();

    this.productName = this.globalVariables.productName;

    let payloadbilling: InstallmentBillingAcceptStatusRequest = {
      policyId: this.globalVariables.policyId,
      versionNum: this.globalVariables.policyVersionId
    };
    this.billingService
      .getInstallmentBillingAcceptStatus(payloadbilling)
      .subscribe(data => {
        if (data) {
          this.installmentBillingDisplay = data.InstallmentBillingAccept;          
        }
      });
      
    let payload: StepRequest = {
      policyId: this.globalVariables.policyId,
      versionNum: this.globalVariables.policyVersionId
    };
    this.appDataService
      .requestDataFromPolicyAndDocumentAPI(payload)
      .subscribe(data => {
        if (data) {
          this.appDataService.updatePolicyDetails(data[0]);
          this.appDataService.updateDocumentsDetail(data[1]);
          this.loaderService.hide();
        }
      });

    this.appDataService.getPolicyDetails().subscribe(res => {
      if (res) {
        this.getCoveragesData(res);
      }
    });
   
    this.appDataService.getDocumentsDetail().subscribe(res => {
      if (res) {
        this.documentsData = res;
        this.signatureMethod = res.SignatureMethod;
        if (this.signatureMethod) {
          this.expandPurchaseAccordian(1);
        }
         //fix: 5356
         if(this.productName!='General Liability'){
          this.expandPurchaseAccordian(1);
        }
        if (
          has(res.SummaryDetails, 'SummaryPendingItem.PolicyStatus') &&
          has(
            this.actionItems,
            'SummaryDetails.SummaryPendingItem.PolicyStatus'
          ) &&
          res.SummaryDetails.SummaryPendingItem.PolicyStatus !=
            this.actionItems?.SummaryDetails.SummaryPendingItem.PolicyStatus
        ) {
          let payload: StepRequest = {
            policyId: this.globalVariables.policyId,
            versionNum: this.globalVariables.policyVersionId
          };
          this.appDataService.fetchAndPublishPolicyDetails(payload);
        }
      }
      if (
        this.actionItems.SummaryDetails.SummaryPendingItem.SubmissionType ===
          'Renewal' &&
        (this.actionItems.SummaryDetails.SummaryBoundItem.PolicyStatus ==
          'Step4NewTxn' ||
          this.actionItems.SummaryDetails.SummaryBoundItem.PolicyStatus ==
            'Step4DwnloadDoc' ||
          this.actionItems.SummaryDetails.SummaryBoundItem.PolicyStatus ==
            'Step4Purchase') &&
        this.documentsData.RequiredDocuments.length == 0
      ) {
        if (
          this.actionItems.SummaryDetails.SummaryBoundItem.PolicyStatus ==
            'Step4NewTxn' ||
          this.actionItems.SummaryDetails.SummaryBoundItem.PolicyStatus ==
            'Step4DwnloadDoc'
        ) {
          let activityPayload: ActivityLogRequest = {
            ActivityType: 'Step4Purchase',
            Amount: this.actionItems.SummaryDetails.SummaryBoundItem
              .PolicyTotal,
            Description: this.actionItems.SummaryDetails.SummaryBoundItem
              .SubmissionStatusDescription,
            LoggedInUser: this.globalVariables.loggedInUser,
            PolicyTxnId: this.globalVariables.policyTxnId
          };
          this.stepsService.activityLogItem(activityPayload).subscribe(res => {
            if (res.Status === Status.Success) {
              this.frmGroup.markAsPristine();
              this.isRenewalNoDocument = true;
              this.selectedAccordian = [...this.selectedAccordian].map(item => {
                return false;
              });
              setTimeout(() => {
                this.signatureMethod = 'false';
                this.documentContinue();
                this.selectedAccordian[0] = false;
                this.selectedAccordian[1] = false;
                this.selectedAccordian[2] = true;
              }, 200);
            }
          });
        } else {
          this.frmGroup.markAsPristine();
          this.isRenewalNoDocument = true;
          this.selectedAccordian = [...this.selectedAccordian].map(item => {
            return false;
          });
          setTimeout(() => {
            this.signatureMethod = 'false';
            this.documentContinue();
            this.selectedAccordian[0] = false;
            this.selectedAccordian[1] = false;
            this.selectedAccordian[2] = true;
          }, 200);
        }
      }
    });
  }

  initFormGroup() {
    const controls = {};

    controls[this.fromDatepickerInfo.fieldName] = ['', Validators.required];

    controls[this.toDatepickerInfo.fieldName] = [
      { value: '', disabled: true },
      Validators.required
    ];

    this.frmGroup = this.fb.group(controls);
    this.saveChangeGaurd.setFormGroup(this.frmGroup);

    this.premiumBillingGroup = new FormGroup({
      XmlRequest: new FormControl('')
    });
  }

  changeDate(selectedDate) {
    if(this.globalVariables.productName ==='Excess Liability')
    {
      this.frmGroup.get(this.toDatepickerInfo.fieldName).setValue(this.formatDate(this.actionItems?.PremiumDetails?.PolicyTermEndDate));
    }
    else
    {
      const d = new Date(selectedDate);
      d.setFullYear(selectedDate.getFullYear() + 1);
      //d.setDate(selectedDate.getDate() - 1);    
      this.frmGroup.get(this.toDatepickerInfo.fieldName).setValue(d);
    }
  }
  gridEvent() {}
  edit() {
    this.dateEdition = true;
  }

  save() {
    this.loaderService.show();
    const requestChangePolicyTerm: StepRequest = {
      policyId: this.globalVariables.policyId,
      versionNum: this.globalVariables.policyVersionId,
      EffectiveDate: this.formatDate(this.frmGroup.value.fromDate),
      ExpirationDate: this.formatDate(
        this.frmGroup.get(this.toDatepickerInfo.fieldName).value
      )
    };
    this.stepsService
      .changePolicyTerm(requestChangePolicyTerm)
      .subscribe(res => {
        if (res.Status.toLowerCase() == 'success') {
          //Global.refreshData = 'true';
          this.alertService.success(res.Message);
          this.appDataService.updatePolicyDetails(res);
          //this.callPolicy();
          this.loaderService.hide();
          this.dateEdition = false;
          this.frmGroup.markAsPristine();
        } else if (res.Status.toUpperCase() === Status.Failure) {
          this.loaderService.hide();
          this.alertService.error(res.Errors.join(','));
        }
      });
  }

  getCoveragesData(data: StepResponse) {
    this.actionItems = data;

    if (this.productName == 'General Liability' &&
     this.appFileUploaded == false &&
     this.installmentBillingDisplay == false &&
     this.actionItems?.SignatureMethod == "eSignature") {
     let installmentBillIndex = this.actionItems?.Payments?.findIndex(
       item => item.Name.toUpperCase() === 'INSTALLMENT BILL'
     );
     if (installmentBillIndex >= 0) {
       this.actionItems?.Payments?.splice(installmentBillIndex, 1);
     }
   }

    this.fromDatepickerInfo.placeholder = this.formatDate(
      this.actionItems?.PremiumDetails?.PolicyTermStartDate
    );
    this.toDatepickerInfo.placeholder = this.formatDate(
      this.actionItems?.PremiumDetails?.PolicyTermEndDate
    );

    //Sorting Table Data
    if (data.Subjectivities && data.Subjectivities.length)
      this.requiredDocuments = data.Subjectivities.sort((a, b) =>
        b.Status.localeCompare(a.Status)
      );

    // this.appFileUploaded =
    //   data.SummaryDetails.SummaryPendingItem.PolicyStatus ===
    //   Status.Step4Purchase;
  }
  formatDate(date) {
    if (date) return this.datePipe.transform(new Date(date), 'MM/dd/yyyy');
  }

  openModal() {
    this.dialogService.open(SignApplicationComponent, this.modalContent);
  }

  // docuSign() {
  //   this.dialogConfig.data = { formID: '6199' };
  //   this.dialogConfig.modalSetting = {
  //     title: Messages.DocuSignPopupHeading,
  //     hideHeader: true,
  //     hideFooter: true,
  //     hideSave: true,
  //     hideHeaderX: true
  //   };
  //   const ref = this.dialogService.open(UCMDialogComponent, this.dialogConfig);
  //   ref.afterClosed.subscribe(result => {
  //     if (result) {
  //     }
  //   });
  // }
  downloadPdfFile(doc: AvailableDocument) {
    this.loaderService.show();
    let endpoint = this.documentService.generateEndpoint(
      doc,
      this.globalVariables.policyId,
      this.globalVariables.policyVersionId
    );
    this.documentService.downloadPdfData(endpoint).subscribe(base64 => {
      this.documentService.downloadPdf(base64.Pdf, doc.Name);
      this.loaderService.hide();
    });
  }
  downloadApp() {
    this.chooseFileFlag = true;
    this.loaderService.show();
    let payload: DownloadDocumentRequest = {
      policyId: this.globalVariables.policyId,
      versionNum: this.globalVariables.policyVersionId
    };

    this.documentService.downloadApplication(payload).subscribe(pdfData => {
      if (has(pdfData, 'Pdf')) {
        this.documentService.openBase64NewTab(pdfData.Pdf);
        this.loaderService.hide();
      }
    });
  }
  handleFileInput(files: FileList, status: string) {
    const selectedFile = files.item(0);
    if (status == 'Download App') {
      this.appFileUpload = selectedFile;
      this.frmGroup.markAsDirty();
    }
  }

  removeDoc(status: string, event) {
    if (status == 'Download App') {
      this.appFileUpload = null;
    }
  }
  fillOutForm() {}
  dirtyCheckEvent(isDirty) {
    if (isDirty) {
      this.frmGroup.markAsDirty();
    } else {
      this.frmGroup.markAsPristine();
    }
  }
  paymentMethodSelect(array, i) {
    array.forEach(item => {
      item.selected = false;
    });
    setTimeout(() => {
      array[i].selected = true;
      this.selectedPaymentMethod = array[i].Name;
      this.installmentAggrement = this.isInstallmentAggrementRequired();      
    }, 200);
  }
  onPurchase(billingType: string) {
    if (this.checkIfDocumentPending()) {
      this.alertService.error("You must upload all 'Prior to Bind'");
      return;
    }    
    let payload: StepRequest = {
      policyId: this.globalVariables.policyId,
      versionNum: this.globalVariables.policyVersionId
    };

    switch (billingType) {
      case BillingType.AgencyBill:
        this.agencyBilling(payload);
        break;
      case BillingType.InstallmentBill:
        this.installmentBill(payload);
        break;
      case BillingType.PaperlessPremiumFinancing:
        this.paperlessPremiumFinancingBill(payload);
        break;
      default:
        break;
    }
  }
  agencyBilling(payload: StepRequest) {
    this.loaderService.show();

    this.billingService
      .purchaseAgencyBilling(payload)
      .subscribe((res: AgencyBillingResponse) => {
        if (res && res.Status === Status.Success) {
          this.loaderService.hide();
          this.alertService.success('Billing information saved successfully');
          this.router.navigate([AllowedBoundNavRoutes.Snapshot]);
        } else if (res.Status.toUpperCase() === Status.Failure) {
          this.loaderService.hide();
          this.alertService.error(
            res.Errors.join(','),
            '',
            'toast-top-right',
            5000
          );
        }
      });
  }

  installmentBill(payload: StepRequest) {
    this.loaderService.show();
    this.billingService
      .redirectInstallmentBill(payload)
      .subscribe((res: RedirectInstallmentBillingResponse) => {
        if (res && res.Status === Status.Success) {
          //this.loaderService.hide();
          let redirectUrl = this.setInstallmentDomainAndLocation(
            res.Input1InstallmentBillRedirectUrl
          );
          location.href = redirectUrl;
        } else if (res.Status.toUpperCase() === Status.Failure) {
          this.loaderService.hide();
          this.alertService.error(
            res.Errors.join(','),
            '',
            'toast-top-right',
            5000
          );
        }
      });
  }

  paperlessPremiumFinancingBill(payload: StepRequest) {
    this.loaderService.show();
    this.billingService
      .redirectPaperlessPremiumFinancing(payload)
      .subscribe((res: RedirectPremiumFinancingResponse) => {
        if (res && res.Status === Status.Success) {
          this.htmlContent = this.setPremiumDomainAndLocation(
            res.Input1PremiumFinancingFormPost
          );
          this.redirectUrl = res.RedirectUrl;

          this.premiumBillingGroup.controls['XmlRequest'].setValue(
            this.htmlContent
          );

          //Set time out to update the action url in html component.
          setTimeout(() => {
            this.premiumBillingElement.nativeElement.submit();
          }, 200);
        } else if (res.Status.toUpperCase() === Status.Failure) {
          this.loaderService.hide();
          this.alertService.error(
            res.Errors.join(','),
            '',
            'toast-top-right',
            5000
          );
        }
      });
  }

  setInstallmentDomainAndLocation(content: string) {
    return content
      .replace(/{domain}/g, location.host)
      .replace(/{location-path}/g, 'shared/callback-installment');
  }
  setPremiumDomainAndLocation(content: string) {
    return content
      .replace(/{domain}/g, location.host)
      .replace(/{location-path}/g, 'shared/callback-premium');
  }
  signatureMethodClicked(signatureMethod: string) {
    if (this.signatureMethod) {
      this.appFileUploaded = false;
      if (this.signatureMethod == signatureMethod) {
        this.expandPurchaseAccordian(1);
        return;
      }
      let content = {
        value: Messages.SignatureMethodChange
      };
      this.dialogConfig.data = content;

      this.dialogConfig.modalSetting = {
        title: Messages.SignatureMethodChangeTitle,
        hideHeader: false,
        hideFooter: true,
        hideSave: true,
        hideHeaderX: false,
        SaveButton: 'Yes',
        CancelButton: 'No',
        dialogSize: DialogSize.SM
      };
      const ref = this.dialogService.open(
        DialogContainerComponent,
        this.dialogConfig
      );
      ref.afterClosed.subscribe(result => {
        if (result) {
          this.saveSignatureMethod(signatureMethod);
        }
      });
    } else {
      this.saveSignatureMethod(signatureMethod);
    }
  }
  saveSignatureMethod(signatureMethod) {
    this.loaderService.show();
    let payload: SaveSignatureMethodRequest = {
      PolicyId: this.globalVariables.policyId,
      VersionNum: this.globalVariables.policyVersionId,
      SignatureMethod: signatureMethod
    };
    this.billingService.saveSignatureMethod(payload).subscribe(res => {
      if (res && res.Status === Status.Success) {
        this.expandPurchaseAccordian(1);
        this.alertService.success('Signature method saved successfully');
        let payloadGetPolicy: StepRequest = {
          policyId: this.globalVariables.policyId,
          versionNum: this.globalVariables.policyVersionId
        };
        this.appDataService.fetchAndPublishPolicyDetails(payloadGetPolicy);
        this.appDataService.fetchAndPublishDocumentsDetail(payloadGetPolicy);
        this.signatureMethod = signatureMethod;
        this.loaderService.hide();
      } else if (res.Status.toUpperCase() === Status.Failure) {
        this.loaderService.hide();
        this.alertService.error(res.Errors.join(','));
      }
    });
  }
  expandPurchaseAccordian(expandIndex: number) {
    this.selectedAccordian = [...this.selectedAccordian].map(item => {
      return false;
    });
    setTimeout(() => {
      this.selectedAccordian[expandIndex] = true;
    }, 200);
  }
  documentContinue() {
    if (this.checkIfDocumentPending()) {
      this.alertService.error("You must upload all 'Prior to Bind'");
      return;
    }
    this.appFileUploaded = true;
    this.expandPurchaseAccordian(2);   
  }

  checkIfDocumentPending() {
    if (this.documentsData.RequiredDocuments.length > 0) {
      let pendingDoc = this.documentsData.RequiredDocuments.find(
        document =>
          document.Due === Status.PriorToBind &&
          document.Status != Status.Completed
      );

      if (pendingDoc) {
        return true;
      }
    }
    return false;
  }
  openAccordian(index, isToggled) {
    let _index = 0;
    this.selectedAccordian.forEach(element => {
      if (_index != index) {
        this.selectedAccordian[_index] = false;
      }
      _index++;
    });
    setTimeout(() => {
      this.selectedAccordian[index] = !isToggled;
    }, 200);
  }

  isInstallmentAggrementRequired() {
    let isExist = this.documentsData.RequiredDocuments.find(
      document =>
        document.Due === 'Optional' &&
        document.Form.Name === 'Installment Bill Agreement'
    );
    if (!isExist) return false;
    return isExist.Status === 'Incomplete';
  }
}
